<template>
  <div class="view contentBody"> 
    <div class="search_wrap">
      <el-form :inline="true" :model="listData" class="form-inline">
        <el-form-item label="核销码">
	            <el-input v-model="listData.ver_code" placeholder="核销码"  class="w160" size="small"></el-input>
	      </el-form-item>
        <el-form-item label="用户昵称">
	            <el-input v-model="listData.nickname" placeholder="用户昵称"  class="w160" size="small"></el-input>
	      </el-form-item>
        <el-form-item label="核销状态">
						<el-select class="mr10 w130" v-model="listData.status" size="small" placeholder="请选择核销状态">
							<el-option label="全部"  :value="0"></el-option>
							<el-option label="已核销" :value="2"></el-option>
							<el-option label="未核销" :value="1"></el-option>
						</el-select>              
					</el-form-item>
        <el-form-item label="分红方案">
          <el-select class="whd-select" clearable v-model="listData.scheme_id" placeholder="分红方案" size="small">
            <el-option
              v-for="(item) in scheme_list"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合伙人">
          <el-select class="whd-select" clearable v-model="listData.partner_id" placeholder="请选择合伙人" size="small">
            <el-option
              v-for="(item) in partner_list"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
	            <el-input v-model="listData.tel" placeholder="联系方式"  class="w160" size="small"></el-input>
	      </el-form-item>
         
        <el-form-item label="消费时间">
          <el-date-picker
            v-model="listData.create_time"
            type="date"
            size="small"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item> 
        <el-form-item>
        <el-button type="primary" size="small" @click="searchData" icon="el-icon-search"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mb20">
          <el-button type="primary" @click="addcustomer" size="small" >手动录入</el-button>
        </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
            label="头像/昵称"
            >
            <template slot-scope="scope">
	            <img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
	            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
              <p>{{scope.row.nickname}}</p>
	          </template>
          </el-table-column>
        <el-table-column label="消费记录">
          <template slot-scope="scope">
              <span class="whd-block">方案：{{scope.row.scheme_name}}</span>
              <span class="whd-block">项目：{{scope.row.goods_name}}</span>
              <span class="whd-block" v-if="scope.row.status==1">消费金额：{{scope.row.money}}(包含佣金{{scope.row.commission}})</span>
            </template>
        </el-table-column> 
        <el-table-column label="联系信息">
          <template slot-scope="scope">
              <span class="whd-block">{{scope.row.name}}</span>
              <span class="whd-block">{{scope.row.tel}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="partner_name" label="归属合伙人"></el-table-column>
        <el-table-column prop="create_time_text" label="消费时间"></el-table-column>
        <!-- <el-table-column prop="ver_code" label="核销码"></el-table-column> -->
        <el-table-column prop="ver_code" label="核销信息"  width="300px">
					<div slot-scope="scope" >
						<p>核销状态：{{scope.row.status_text}} 
							<span v-if="scope.row.verification_time_text">（{{scope.row.verification_time_text}}）</span>
							</p>
						<p>核销码：{{scope.row.ver_code}}</p>
						<p>有效期：{{scope.row.expire_time_text}}</p>
					</div>
				</el-table-column>
        <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
						<p>
							<el-button type="primary" style="width:80px" size="small" icon="el-icon-edit"  @click="open(scope.row.id,scope.row.ratio,scope.row.profit)" v-if="scope.row.status==0">核销</el-button>
							<el-button type="primary" style="width:80px" size="small"  @click="open(scope.row.id)" disabled v-if="scope.row.status==1">已核销</el-button>
            </p>
            <p style="margin-top:10px">
              <el-button type="primary" style="width:80px" size="small"   @click="addcustomer(scope.row.id)">再次入单</el-button>
            </p>
					</template>
          </el-table-column>

      </el-table>       
    </div>  
    <div class="pag_wrap">
      <el-pagination
        background
        :page-size="page.page_size"
        :current-page="page.current_page"
        layout="total, prev, pager, next"
        :total="page.total_rows"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div>  
   <buyhexDialog v-if="showIntegral" :visible.sync="showIntegral" :riziId="riziId" :ratio="ratio"  :profit="profit" @initFn="InitFn"></buyhexDialog>
  </div> 
</template>

<script>

import { pagination } from "@/util/util.js";
import api from "@/api.js";
import buyhexDialog from "@/components/dialog/buyhexDialog.vue";
export default {
  name: "buy",
  components: {
      buyhexDialog
    }, 
  data() {
    return {  
      publisher_list:[],
      tableData: [],
      scheme_list: [],
      partner_list:[],
      dialogContent: null,
      page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total
      },
      showIntegral: false, 
      listData: {
        nickname: '',
        tel: '',
        partner_id: '',
        create_time: '',
        scheme_id:'',
        partner_id:'',
        status: 0,//核销状态，0全部，1未核销，2已核销
        page: 1,
        
      }    
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    InitFn() {
      this.axios
        .post(api.partner_buyLog, this.listData)
        .then(response => {
          if (response.data.code == 0) {
            this.scheme_list = response.data.result.scheme_list;
            this.partner_list = response.data.result.partner_list;
            this.tableData = response.data.result.lists;
            this.page = response.data.page;
            // this.page.total = response.data.page.total_rows      
          } 
        })
        .catch(() => {});      
    },
    pageIndexChange(pageindex) {
      this.listData.page = pageindex;
      this.InitFn();
    },
   //搜索
    searchData(){
      this.listData.page = 1;
      // console.log('1111==',this.scheme_list)
      // console.log('1111==',this.listData)
      this.InitFn()
    },
    //核销弹框
			// open(id){
			// 	console.log('核销',id)
			// 	// this.$prompt('核销购买商品', '请输入核销码', {
      //   //   confirmButtonText: '核销',
      //   //   cancelButtonText: '取消',
    
			// 	// })
			// 	this.$confirm('是否确定核销?（核销码：'+ id +'）', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   })
			// 	.then(() => {
			// 		this.axios
			// 			.post(api.partner_buyCheck,{data_id:id})
			// 			.then(res=>{
			// 				if(res.data.code == 0){
			// 					this.$message.success(res.data.msg);
			// 					setTimeout(()=>{   //设置延迟执行
			// 						location.reload()
			// 					},2000);
			// 				}
			// 			}).catch(res => {});
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '取消核销'
      //     });       
      //   });
			// },
    addcustomer(id) {
      // this.$router.push({name: 'addcustomer'});
      this.$router.push({name: 'addcustomer', params: {id: id}});
    },
    // 核销弹窗
    open(option,ratio,profit) {
      // console.log('11', option)
      // console.log('22', ratio)
      // console.log('22', profit)
        this.riziId = option;
        this.ratio = ratio;
        this.profit = profit;
        this.showIntegral = true;
      }
    
  }
}
</script>
